<div class="review-compliance-main" *ngIf="allQuestions$ | async">
  <div
    *ngFor="
      let question of allQuestions?.vsExportComplianceQuestions;
      let i = index
    "
  >
    <!--Questions-->
    <span>{{ i + 1 }} . </span>
    <span class="mt-question" [innerHTML]="question.question"> </span>
    <div class="row question">
      <label *ngIf="complianceQuestionData[question.questionId]">{{ "quoteReview.radioYes" | cxTranslate }}  </label>
      <label *ngIf="!complianceQuestionData[question.questionId]">{{ "quoteReview.radioNo" | cxTranslate }}  </label>
    </div>
    <div
      *ngIf="
        complianceQuestionData[question?.questionId] == true &&
        question?.questionId == 'warningFlags'
      "
      class="warning-text-flag"
    >
      {{ warningFlagText }}
    </div>
  </div>
</div>
